import { render } from "./AllReviews.vue?vue&type=template&id=3d701284"
import script from "./AllReviews.vue?vue&type=script&lang=js"
export * from "./AllReviews.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__